var _metadata, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 16 16",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M6 0h4M6 1h1M9 1h1M5 2h1M10 2h1M5 3h1M10 3h1M5 4h1M10 4h1M5 5h1M10 5h1M4 6h1M11 6h1M4 7h1M11 7h1M4 8h1M11 8h1M3 9h1M12 9h1M3 10h1M12 10h1M3 11h1M12 11h1M3 12h1M12 12h1M3 13h1M12 13h1M3 14h10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#917708",
    d: "M7 1h2M7 2h2M7 3h2M7 4h2M7 5h2M7 6h2M7 7h2M7 8h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#824618",
    d: "M6 2h1M9 2h1M6 3h1M9 3h1M6 4h1M9 4h1M6 5h1M9 5h1M5 6h2M9 6h2M5 7h2M9 7h2M5 8h2M9 8h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#692e00",
    d: "M4 9h8M4 10h8M4 11h8M4 12h8M4 13h8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetro);
export default __webpack_public_path__ + "static/media/metro.67d33932546f8019e74242d8aa4d8674.svg";
export { ForwardRef as ReactComponent };